/* global _ */
import { get } from 'lodash';

/* @ngInject */
export default class {
  constructor($q, $log, ApiClass, ProfileClass) {
    this.$q = $q;
    this.$log = $log;
    this.ApiClass = ApiClass;
    this.ProfileClass = ProfileClass;
    this.vendor_arr = [];
    this.vendor_dict = {};
    this._request = false;
    this._request_error = false;
    this.loadVendors();
  }

  convertUser(vendor_id) {
    const { convert_user, company_id } = get(this.vendor_dict, `${vendor_id}`, { convert_user: false });

    return convert_user ? company_id : undefined;
  }

  loadVendors(update) {
    if (!update && (this._request && !this._request_error)) {
      return this._request;
    }

    this._request = this.$q((resolve, reject) => {
      const company_id = this.ProfileClass.company_id;

      this.ApiClass.companiesIdTypeGet({
        id: company_id,
        type: 'vendors',
        manage: false
      })
        .then(({ data: { items } }) => {
          if (_.isEmpty(items)) {
            return resolve({
              arr: this.vendor_arr,
              obj: this.vendor_dict
            });
          }

          this.vendor_arr = items;
          items.forEach(vendor => {
            this.vendor_dict[vendor.vendor_id] = vendor;
          });

          resolve({
            arr: this.vendor_arr,
            obj: this.vendor_dict
          });
        })
        .catch(error => {
          this._request_error = true;
          $log.error(error);
          reject(error);
          throw error;
        });
    });

    return this._request;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/VendorClass.js